import { render, staticRenderFns } from "./ProjectPreference.vue?vue&type=template&id=1fbb5990&"
import script from "./ProjectPreference.vue?vue&type=script&lang=js&"
export * from "./ProjectPreference.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPreference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports